__turbopack_context__.v({
  "className": "great_vibes_715259a9-module__FEPkLa__className",
});
